import React from 'react';
import { toast } from 'react-toastify';

import { ItemToast } from 'tradera-components/toasts/item-toast';
import { webApiClient } from '../utils/http';
import { createQueue } from './toast-queue';

const queuedToasts = createQueue();

export const ToastTestButton = () => (
    <button
        onClick={() => {
            showItemWishListReminderToast(85391643, 3);
            showItemOutbiddedToast(85391639, 99);
            showItemFirstBidToast(85391639);
            showItemSoldToast(85391639, 1234);
            showItemWonToast(85391639, 1234);
            showItemPaidToast(85391639);
            // toast.error('Something went wrong');
            // toast.info('You need to include something! A bit longer text.');
            // toast.success('Successfully did something');
        }}>
        Test
    </button>
);

const openNextToast = async () => {
    if (queuedToasts.isInProgress()) {
        return;
    }
    const nextItem = queuedToasts.next();
    if (nextItem) {
        try {
            const response = await webApiClient.get(
                `/browse/item-basic-info/${nextItem.eventData.itemId}`
            );
            const { imageUrl, itemUrl, shortDescription } = response.data.item;
            const queueLength = queuedToasts.getLength();
            toast(
                React.createElement(ItemToast, {
                    imageUrl,
                    itemUrl,
                    shortDescription,
                    type: nextItem.type,
                    eventData: nextItem.eventData
                }),
                {
                    autoClose: Math.max(2, 5 - queueLength) * 1000,
                    onClose: () => {
                        queuedToasts.notifyDone();
                        openNextToast();
                    }
                }
            );
        } catch (e) {
            queuedToasts.notifyDone();
            openNextToast();
            throw e;
        }
    }
};

const handleNotification = async (type, eventData, ttlInMinutes = 10) => {
    if (document.visibilityState !== 'visible') {
        // We don't want to show messages if page is not visible. If we do they will queue up!
        return;
    }

    queuedToasts.add({ type, eventData }, ttlInMinutes);
    openNextToast();
};

export const showItemOutbiddedToast = (itemId, newLeadingBidAmount) =>
    handleNotification('ItemOutbidded', {
        itemId,
        newLeadingBidAmount
    });

export const showItemFirstBidToast = itemId =>
    handleNotification('ItemFirstBid', { itemId });

export const showItemSoldToast = (itemId, price) =>
    handleNotification('ItemSold', { itemId, price });

export const showItemWonToast = (itemId, price) =>
    handleNotification('ItemWon', { itemId, price });

export const showItemPaidToast = itemId =>
    handleNotification('ItemPaid', { itemId });

export const showItemWishListReminderToast = (itemId, timeLeftMinutes) =>
    handleNotification(
        'ItemWishListReminder',
        { itemId, timeLeftMinutes },
        timeLeftMinutes > 10 ? 10 : 2
    );
